export default __webpack_public_path__ + "static/media/53-min.1ab4f3cd.jpg";